import _defineProperty from "@babel/runtime/helpers/defineProperty";
import * as React from 'react';
import { EArrowsSize } from '../../../../types';
import { IconChevronLeft16, IconChevronRight16 } from '@cian/ui-kit/icons';
import { jsx as _jsx } from "react/jsx-runtime";
export var LeftLargeArrow = function LeftLargeArrow() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsx("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.58594 7.99993L11.293 0.292818L12.7073 1.70703L6.41436 7.99993L12.7073 14.2928L11.293 15.707L3.58594 7.99993Z",
        fill: "white"
      })
    })
  );
};
export var RightLargeArrow = function RightLargeArrow() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsx("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4141 7.99993L5.70696 0.292818L4.29274 1.70703L10.5856 7.99993L4.29274 14.2928L5.70696 15.707L13.4141 7.99993Z",
        fill: "white"
      })
    })
  );
};
var LEFT_ARROWS_MAP = _defineProperty(_defineProperty({}, EArrowsSize.LARGE, /*#__PURE__*/_jsx(LeftLargeArrow, {})), EArrowsSize.NORMAL, /*#__PURE__*/_jsx(IconChevronLeft16, {
  color: "icon-inverted-default"
}));
var RIGHT_ARROWS_MAP = _defineProperty(_defineProperty({}, EArrowsSize.LARGE, /*#__PURE__*/_jsx(RightLargeArrow, {})), EArrowsSize.NORMAL, /*#__PURE__*/_jsx(IconChevronRight16, {
  color: "icon-inverted-default"
}));
export var getLeftArrow = function getLeftArrow(size) {
  return LEFT_ARROWS_MAP[size];
};
export var getRightArrow = function getRightArrow(size) {
  return RIGHT_ARROWS_MAP[size];
};